'use strict';

let formValidation = require('../components/formValidation');
const { isEmpty } = require('lodash');

const STATES = {
    initial: 'initial',
    amount: 'amount',
    form: 'form'
};
var currentState = STATES.initial;
var giftCardType;
var selectedAmount = 0;

const SELECTORS = {
    selectTypeCard: '.gift-certificate__type-card',
    selectTypeCta: '.gift-certificate__type-card .gift-certificate__type-card-btn-select',
    selectTypeCtaSelected: '.gift-certificate__type-card .gift-certificate__type-card-btn-selected',
    selectAmount: '.gift-certificate__select-amount',
    amountCta: '.gift-certificate__select-amount .gift-certificate__amount',
    customAmountInput: '.gift-certificate__select-amount .gift-certificate__custom-amount',
    amountNextStep: '.gift-certificate__select-amount .gift-certificate__next-step',
    formSection: '.gift-certificate__form-section',
    formInputAmount: '.gift-certificate__form-section input.gift-certificate__input-amount',
    formInputType: '.gift-certificate__form-section input.gift-certificate__input-type',
    formSubmit: '.gift-certificate__form-submit',
    formToDNone: '.toHide',
    formSenderName: 'input#senderName',
    formReceiverName : 'input#recivererName',
    formReceiverEmail: 'input#reciverEmail',
    formReceiverEmailConfirm: 'input#confirmReciverEmail'
}

module.exports = {
    landingPageStates: function () {
        $(document).on('click',SELECTORS.selectTypeCta, (e) => {
            $(SELECTORS.selectTypeCard).removeClass('selected');
            const $selectedTypeCard = $(e.currentTarget).closest(SELECTORS.selectTypeCard);
            $selectedTypeCard.addClass('selected');
            giftCardType = $selectedTypeCard.data('type');
            $(SELECTORS.formInputType).val(giftCardType);
            $(`${SELECTORS.selectAmount}, ${SELECTORS.formSection}`).removeClass('hidden');
            $([document.documentElement, document.body]).animate({
                scrollTop: $(SELECTORS.selectAmount).offset().top - window.innerHeight * 0.25
            }, 1000);
            currentState = STATES.amount;

        });

        $(document).on('click', SELECTORS.amountCta, (e) => {
            const $amountInput = $(SELECTORS.customAmountInput);
            $amountInput.val('');
            const $clickedButton = $(e.currentTarget);
            $(SELECTORS.amountCta).removeClass('selected');
            $clickedButton.addClass('selected');
            selectedAmount = $clickedButton.data('amount');
            $(SELECTORS.amountNextStep).removeClass('disabled');
            $(SELECTORS.amountNextStep).removeClass('continued');
            $('.error-label').addClass('d-none');
            if(currentState == STATES.form) {
                $(SELECTORS.formSection).addClass('disabled');
            }
        })

        $(document).on('keyup', SELECTORS.customAmountInput, (e) => {
            const $amountInput = $(e.currentTarget);
            $(SELECTORS.amountCta).removeClass('selected');
            $amountInput.addClass('selected');
            selectedAmount = $amountInput.val();
            console.log(selectedAmount);
            $(SELECTORS.amountNextStep).removeClass('disabled');
            $(SELECTORS.amountNextStep).removeClass('continued');
            if(currentState == STATES.form) {
                $(SELECTORS.formSection).addClass('disabled');
            }

            $(SELECTORS.customAmountInput).attr("min", 50);
            $(SELECTORS.customAmountInput).attr("max", 1000);

            if ($(SELECTORS.customAmountInput).val() < 50 || $(SELECTORS.customAmountInput).val() > 1000) {
              $('.error-label').removeClass('d-none');
              $(SELECTORS.amountNextStep).addClass('disabled');
            } else {
                $('.error-label').addClass('d-none')
            }
        })
        $(document).on('click', SELECTORS.amountNextStep, (e) => {
            //select classe aggiuntiva add.(d-none)
            if (giftCardType === 'physical') {
                $(SELECTORS.formToDNone).addClass('d-none');
                $(SELECTORS.formToDNone).removeClass('required');
            } else {
                $(SELECTORS.formToDNone).removeClass('d-none');
                $(SELECTORS.formToDNone).addClass('required');
            }
            $(SELECTORS.formSection).removeClass('disabled');
            $([document.documentElement, document.body]).animate({
                scrollTop: $(SELECTORS.formSection).offset().top - window.innerHeight * 0.25
            }, 1000);
            currentState = STATES.form;
            $(SELECTORS.amountNextStep).addClass('continued');
            $(SELECTORS.formInputAmount).val(selectedAmount);
        })

        $("input").on('keyup',function() {
            var canAdded
            if (giftCardType === 'physical') {
                canAdded = !isEmpty($(SELECTORS.formSenderName).val()) && !isEmpty($(SELECTORS.formReceiverName).val())
            } else {
                canAdded = !isEmpty($(SELECTORS.formSenderName).val()) && !isEmpty($(SELECTORS.formReceiverName).val()) && !isEmpty($(SELECTORS.formReceiverEmail).val()) && !isEmpty($(SELECTORS.formReceiverEmailConfirm).val())
            }
            if (canAdded) {
                $(SELECTORS.formSubmit).removeClass('disabled');
            } else {
                $(SELECTORS.formSubmit).addClass('disabled');
            }
        })
    },
    test: function () {

    },
    submit: function () {
        $(SELECTORS.formSubmit).on('click', function (e) {
          let form = $(e.currentTarget).closest('form');
          e.preventDefault();
          let url = form.attr('action');
          console.log(form.serialize());
          //form.spinner().start();
          $('form.login').trigger('login:submit', e);
          $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
              if (data.dataLayer) {
                window.dataLayer.push(data.dataLayer);
              }
              console.log(data);
              if (!data.success) {
                formValidation(form, data);
                $('form.giftcertificateform').trigger('giftcertificate:error', data);
              } else {
                $('form.giftcertificateform').trigger('giftcertificate:success', data);
                location.href = data.redirectUrl;
              }
                handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                miniCartReportingUrl(data.reportingURL);
            },
            error: function (data) {
              if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
              } else {
                $('form.giftcertificateform').trigger('giftcertificate:error', data);
                //form.spinner().stop();
              }
            },
          });
          return false;
        });
      }

}
function handlePostCartAdd(response) {
    window.EventBus.emit(window.CUSTOM_MESSAGES.MINICART.UPDATE, { ...response, preventShow: false });
    $('.minicart').trigger('count:update', response);
    let messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        $('.add-to-cart-messages').append('<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' + response.message + '</div>');

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            },
        });
    }
}
